import { Pipe, PipeTransform } from '@angular/core';

import { Référentiel } from '../../administration/gestion-référentiels/models/référentiel.model';
import { Étape } from '../../référentiel-métier-parcours/models/étape.model';

@Pipe({
  name: 'computeFormationsParIm',
})
export class ComputeFormationsParImPipe implements PipeTransform {
  transform(référentiels: (Référentiel & { etapes: Étape[] })[]): number {
    return référentiels.flatMap((x) => x.etapes).length;
  }
}
